function Header({ totalPlants, needsWaterCount }) {
  
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <span className="logo-icon">🌿</span>
          <h1 className="logo-text">Plantie</h1>
        </div>
        
        <div className="header-stats">
          <div className="stat">
            <span className="stat-icon">🌱</span>
            <span className="stat-text">
              <strong>{totalPlants}</strong> plants
            </span>
          </div>
          
          <div className="stat stat-alert">
            <span className="stat-icon">💧</span>
            <span className="stat-text">
              <strong>{needsWaterCount}</strong> need water
            </span>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header